import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';

import { AuthService } from '../services/auth.service';

@Injectable()
export class SettingsService {

//  private apiBasicURL = 'http://localhost:62281/odata/'; 
  private apiBasicURL = 'http://webapilagerservicesowentus.azurewebsites.net/odata/'; //
  private gesamtURL: string;
  private TOKEN: string;

  constructor(public tokenService: AuthService) {
     this.TOKEN = this.tokenService.getToken();
      console.log("Settings Constructor Token = " + this.TOKEN);
   }

  // Erstellt eine URL aus der BasisURL + dem Controllernamen
  getURL(controller: string): string {
    this.gesamtURL = [this.apiBasicURL, controller].join('');
    console.log("Gesamt-URL:" + this.gesamtURL);
    return  [this.apiBasicURL, controller].join('');
  }

  // Erstellt den Standard Header mit Session-Token aus der Anmeldung
  getHeader(): Headers {
     this.TOKEN = this.tokenService.getToken();
      console.log("Settings getHeader Token = " + this.TOKEN);
     
     const headers: Headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      headers.append('Accept', 'text/plain');
      headers.append('Accept', '*/*');  
      headers.append('Authorization', 'Bearer ' + this.TOKEN);    
      return headers;
  }
}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/services/settings.service.ts